import { useCallback } from "react";

import { customToast } from "../../../../components/notify";
import { type IUploadFileParams } from "../../types";
import { useUploadFileMutation } from "../services/kioskApiSlice";

const useUploadAssets = () => {
    const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

    const handleUploadFile = useCallback(
        async (params: IUploadFileParams) => {
            try {
                return await uploadFile(params).unwrap();
            } catch (error) {
                customToast.error("Upload file failed");
                return null;
            }
        },
        [uploadFile]
    );

    return { handleUploadFile, isUploading };
};

export default useUploadAssets;
